/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_AGREEMENT_DETAILS_REQUEST,
  FETCH_AGREEMENT_DETAILS_SUCCESS,
  FETCH_AGREEMENT_DETAILS_FAILURE,
} from "./AgreementDetailsTypes";

const initialState = {
  loading: false,
  agreementDetails: null,
  error: "",
};

const agreementDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AGREEMENT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_AGREEMENT_DETAILS_SUCCESS:
      return {
        loading: false,
        agreementDetails: action.payload,
        error: "",
      };

    case FETCH_AGREEMENT_DETAILS_FAILURE:
      return {
        loading: false,
        agreementDetails: null,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default agreementDetailsReducer;
